import AffiliateMap from "../constants/affiliates";
import { logUserInteraction } from "../api/logging";

export const externalLinkWrapper = (url, affiliateLinksAreOff) => {
  try {
    if (affiliateLinksAreOff) {
      const formattedUrl = url.slice(0, 4) !== "http" ? `http://${url}` : url;
      window.open(formattedUrl, "_blank").focus();
      return;
    }
    let formattedUrl = url.slice(0, 4) !== "http" ? `http://${url}` : url;
    const domain = new URL(formattedUrl);
    const finalDomain = domain.hostname
      .replaceAll("www.", "")
      .split(".")[0]
      .toLowerCase();
    const affiliateKey = Object.keys(AffiliateMap).find((key) => {
      return AffiliateMap[key].domain === finalDomain;
    });
    logUserInteraction("linkClick", affiliateKey);
    if (!affiliateKey) {
      window.open(formattedUrl, "_blank").focus();
      return;
    }
    const { baseUrl, rule, stripFunction } = AffiliateMap[affiliateKey];
    if (rule === "prependUrl") {
      formattedUrl = formattedUrl.split("?")[0];
      const affUrl = `${formattedUrl}${baseUrl}`;
      window.open(affUrl, "_blank").focus();
      return;
    }
    if (rule === "appendUrl") {
      formattedUrl = formattedUrl.split("?")[0];
      const affUrl = `${baseUrl}${encodeURIComponent(formattedUrl)}`;
      window.open(affUrl, "_blank").focus();
      return;
    }
    if (rule === "stripAndPrependUrl") {
      const strippedUrl = stripFunction(url);
      const affUrl = `${strippedUrl}${baseUrl}`;
      window.open(affUrl, "_blank").focus();
      return;
    }
    window.open(formattedUrl, "_blank").focus();
  } catch (error) {
    console.log(error);
    const formattedUrl = url.slice(0, 4) !== "http" ? `http://${url}` : url;
    window.open(formattedUrl, "_blank").focus();
  }
};

export const logLinkClick = (url) => {
  let formattedUrl = url.slice(0, 4) !== "http" ? `http://${url}` : url;
  const domain = new URL(formattedUrl);
  const finalDomain = domain.hostname
    .replaceAll("www.", "")
    .split(".")[0]
    .toLowerCase();
  const affiliateKey = Object.keys(AffiliateMap).find((key) => {
    return AffiliateMap[key].domain === finalDomain;
  });
  logUserInteraction("linkClick", affiliateKey);
};

export const getExternalUrl = (url, affiliateLinksAreOff, product) => {
  try {
    if (affiliateLinksAreOff) {
      const formattedUrl = url.slice(0, 4) !== "http" ? `http://${url}` : url;
      return formattedUrl;
    }
    let formattedUrl = url.slice(0, 4) !== "http" ? `http://${url}` : url;
    const domain = new URL(formattedUrl);
    const finalDomain = domain.hostname
      .replaceAll("www.", "")
      .split(".")[0]
      .toLowerCase();
    const affiliateKey = Object.keys(AffiliateMap).find((key) => {
      return AffiliateMap[key].domain === finalDomain;
    });
    if (!affiliateKey) {
      return formattedUrl;
    }
    const { baseUrl, rule, stripFunction } = AffiliateMap[affiliateKey];
    if (rule === "prependUrl") {
      formattedUrl = formattedUrl.split("?")[0];
      const affUrl = `${formattedUrl}${baseUrl}`;
      return affUrl;
    }
    if (rule === "appendUrl") {
      formattedUrl = formattedUrl.split("?")[0];
      const affUrl = `${baseUrl}${encodeURIComponent(formattedUrl)}`;
      return affUrl;
    }
    if (rule === "stripAndPrependUrl") {
      const strippedUrl = stripFunction(url);
      const affUrl = `${strippedUrl}${baseUrl}`;
      return affUrl;
    }
    return formattedUrl;
  } catch (error) {
    console.log(error);
    if (!url) {
      return product?.url;
    }
    const formattedUrl = url.slice(0, 4) !== "http" ? `http://${url}` : url;
    return formattedUrl;
  }
};

export const getAffiliateKey = (url) => {
  if (!url) return null;
  let formattedUrl = url.slice(0, 4) !== "http" ? `http://${url}` : url;
  const domain = new URL(formattedUrl);
  const finalDomain = domain.hostname
    .replaceAll("www.", "")
    .split(".")[0]
    .toLowerCase();
  const affiliateKey = Object.keys(AffiliateMap).find((key) => {
    return AffiliateMap[key].domain === finalDomain;
  });
  return affiliateKey;
};
